import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast";
import { useToast } from "../hooks/use-toast";
import { CheckCircle2, XCircle, Info } from "lucide-react";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        // Determine icon based on variant
        const Icon = variant === "destructive"
          ? XCircle
          : variant === "success"
            ? CheckCircle2
            : Info;

        const iconColor = variant === "destructive"
          ? "text-red-400"
          : variant === "success"
            ? "text-emerald-400"
            : "text-cyan-400";

        const borderColor = variant === "destructive"
          ? "border-red-500/30"
          : variant === "success"
            ? "border-emerald-500/30"
            : "border-cyan-500/30";

        const glowClass = variant === "destructive"
          ? "shadow-[0_0_15px_rgba(239,68,68,0.15)]"
          : variant === "success"
            ? "shadow-[0_0_15px_rgba(16,185,129,0.15)]"
            : "shadow-[0_0_15px_rgba(6,182,212,0.15)]";

        return (
          <Toast
            key={id}
            {...props}
            className={`
              bg-card/95 backdrop-blur-sm border ${borderColor} ${glowClass}
              data-[state=open]:animate-in data-[state=closed]:animate-out
              data-[state=closed]:fade-out-80 data-[state=open]:fade-in-0
              data-[state=open]:slide-in-from-bottom-full
            `}
          >
            <div className="flex items-start gap-3">
              <div className={`flex-shrink-0 mt-0.5 ${iconColor}`}>
                <Icon className="h-5 w-5" />
              </div>
              <div className="grid gap-1 flex-1">
                {title && (
                  <ToastTitle className="text-sm font-semibold text-foreground">
                    {title}
                  </ToastTitle>
                )}
                {description && (
                  <ToastDescription className="text-sm text-muted-foreground">
                    {description}
                  </ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose className="text-muted-foreground hover:text-foreground" />
          </Toast>
        );
      })}
      <ToastViewport className="fixed bottom-0 right-0 z-[100] flex max-h-screen w-full flex-col p-4 md:max-w-[420px]" />
    </ToastProvider>
  );
}
